import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const FolderServerlessFunctionIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "FolderServerlessFunction",
    children: /*#__PURE__*/_jsx("path", {
      d: "M26.37 9.75h-9.99a.53.53 0 0 1-.44-.37l-1.16-3.4a3.63 3.63 0 0 0-3.45-2.5H8.06c-1.56 0-2.94.99-3.44 2.47l-1.5 4.54c-.13.37-.2.75-.2 1.14v12.18c0 .17.02.35.05.52-.57.5-.92 1.19-.98 1.94-.03.53.16 1.05.53 1.43.51.52 1.21.82 1.94.81.96-.07 1.86-.45 2.59-1.07h19.31a3.63 3.63 0 0 0 3.63-3.63V13.37a3.63 3.63 0 0 0-3.63-3.63Zm-13.62 2.8c-.5-.58-.91-.91-1.25-.91s-.73.2-1.23 3.53h1.89l-.39.77c-.28 0-1.31.11-1.62.11-.26 1.59-.47 3.03-.91 5.35-.54 2.9-1.58 3.96-2.8 4.97a3.4 3.4 0 0 1-1.96.91c-.66 0-1.23-.44-1.23-.91.05-.46.29-.89.65-1.18.15-.11.25-.11.34 0a3 3 0 0 0 1.45.79c.74 0 .83-1.16 1.3-4.04.41-2.4.67-3.95.97-5.86H6.61l-.09-.19.54-.69h1.12c.2-1.2.76-2.3 1.62-3.16.73-.8 1.74-1.3 2.82-1.4.91 0 1.36.37 1.36.8-.09.47-.36.88-.74 1.16-.15.09-.28.15-.44-.05h-.04Zm8.4 10.47h-4.07v-.56c.69-.11.69-.27.39-.77l-.82-1.37c-.31.44-.65.95-.91 1.34s-.25.69.49.8v.56h-3.09v-.56c.72-.06 1.38-.43 1.82-1.01.39-.48.84-1.09 1.33-1.77l-1.44-2.31c-.49-.76-.65-.91-1.54-1.06v-.55h3.91v.55c-.54.12-.65.26-.42.64l.75 1.26c.34-.48.65-.95.84-1.25s.13-.54-.53-.64v-.56h3.03v.55c-.72 0-1.4.37-1.77.99-.25.29-.62.76-1.19 1.52l1.57 2.46c.3.68.94 1.15 1.68 1.23l-.04.53Z"
    })
  }));
};